import Vue from "Vue";
import Vuex from 'vuex';
import axios from "../axios-auth";
import router from '../router';
import globalAxios from 'axios';
import moment from 'moment'
import flatpickr from "flatpickr";
import {english} from "flatpickr/dist/l10n/default.js";
import {Dutch} from "flatpickr/dist/l10n/nl.js";
import {French} from "flatpickr/dist/l10n/fr.js";

Vue.use(Vuex);

function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
}


export default new Vuex.Store({
  state: {
    config:null,
    userReviewComments: [],
    reviewComments: [],
    commentCount: 0,
    flatpickrElements: [],
    theme: localStorage.getItem('theme') || 'darkmode',
    lang: localStorage.getItem('lang') || 'en',
    viewMode: localStorage.getItem('viewMode') || 'user',
    teamTree: JSON.parse(localStorage.getItem('tree')) || null,
    teamManagerTree: JSON.parse(localStorage.getItem('managertree')) || null,
    treeTime: JSON.parse(localStorage.getItem('treeTime')) || null,
    treeManagerTime: JSON.parse(localStorage.getItem('treeManagerTime')) || null,
    idToken: localStorage.getItem('user-token') || null,
    userId: localStorage.getItem('user-id') || null,
    setupComplete: false,
    url: "",
    port: "",
    user: null,
    company: {},
    teams: [],
    managedTeams: [],
    teamFilters: {},
    answers: {},
    lastanswers:{},
    draftAnswers: null,
    submittedAnswers: null,
    previousAnswers: null,
    vitaminFormData: { //stores data from previous draft and final vitamin submissions
      previous: {
        answers: {}
      },
      draft: {
        answers: {}
      },
      submitted: {
        answers: {}
      },
    }
  },
  mutations: {
    setCountries(state,countries){
      state.countries = countries
    },
    clearDraftAnswers(state) {
      state.answers = {}
    },
    setDraftAnswer(state, answer) {
      let answers = state.answers;
      answers[answer.id] = answer.score;
      state.answers = answers;
      // Vue.set(state.answers,answer.id,answer.score)
    },
    clearLastAnswers(state) {
      state.lastanswers = {}
    },
    setLastAnswer(state, answer) {
      let answers = state.lastanswers;
      answers[answer.id] = answer.score;
      state.lastanswers = answers;
      // Vue.set(state.lastanswers,answer.id,answer.score)
    },
    addReviewComment(state, comment) {
      state.reviewComments.push(comment);
    },
    resetReviewComments(state) {
      state.reviewComments = []
    },
    setDraftAnswers(state, answers) {
      state.draftAnswers = answers
    },
    setSubmittedAnswers(state, answers) {
      state.submittedAnswers = answers
    },
    setPreviousAnswers(state, answers) {
      state.previousAnswers = answers
    },
    increaseComment(state) {
      //   console.log('increasing comment')
      state.commentCount++;
    },
    reduceComment(state) {
      //  console.log('reducing comment')
      state.commentCount--;
    },
    addFlatpickr(state, fpElement) {
      state.flatpickrElements.push(fpElement)
    },
    setManagedTeams(state, teams) {
      state.managedTeams = teams;
    },
    setSetupStatus(state, status) {
      state.setupComplete = status
    },
    setUrl(state, url) {
      state.url = url
    },
    setCompany(state, company) {
      state.company = company
    },
    setPort(state, port) {
      state.port = port
    },
    setConfig(state, config) {
      state.config = null;
      state.config = config
    },
    setTree(state, tree) {
      state.teamTree = tree;
    },
    setTreeTime(state, time) {
      state.treeTime = time
    },
    setManagerTree(state, tree) {
      state.teamManagerTree = tree;
    },
    setManagerTreeTime(state, time) {
      state.treeManagerTime = time
    },
    setTheme(state, theme) {
      state.theme = theme;
      // console.log('theme set to', theme)
    },
    setLang(state, lang) {
      state.lang = lang;
      // console.log('lang set to', lang)
    },
    addTeamFilter(state, filter) {
      // console.log('mutation adding filter', filter)
      state.teamFilters[filter.i] = filter;
    },
    removeTeamFilter(state, i) {
      if (state.teamFilters[i]) {
        delete state.teamFilters[i]
        // state.teamFilters[i].field = null;
      }
    },
    removeAllFilters(state) {
      state.teamFilters = {}
    },
    setUser(state, user) {
      state.user = user
    },
    authUser(state, userData) {
      state.idToken = userData.token;
      state.userId = userData.userId;
      state.user = userData.user;
    },
    signOut(state) {
      state.idToken = null;
      state.userId = null;
      state.user = null;
      localStorage.removeItem('user');
      router.push('/signin')
    },
    changeViewMode(state, mode) {
      state.viewMode = mode;
      // console.log('current mode:', state.viewMode)
    },
    resetVitaminData(state) { //todo reset loaded data on new vitamin
      state.vitaminFormData.draft.answers = {};
      state.vitaminFormData.previous.answers = {};
      state.vitaminFormData.submitted.answers = {}
    },
    setVitaminData(state, [data, type]) {
      const answers = {};
      if (type === 'previous') {
        // console.log('previous data received in store:', data)
        if (data.data) {
          state.vitaminFormData.previous = data.data;
          if (data.data.answers) {
            data.data.answers.forEach((answer) => {
              answers[answer.question] = answer
            });
          }
          state.vitaminFormData.previous.answers = answers;
        }
      }
      if (type === 'draft') {
        // console.log('draft data received in store:', data)
        state.vitaminFormData.draft = data.data;
        data.data.answers.forEach((answer) => {
          answers[answer.question] = answer
        });
        state.vitaminFormData.draft.answers = answers;
      }
      if (type === 'submitted') {
        state.vitaminFormData.submitted = data.data;
        data.data.answers.forEach((answer) => {
          answers[answer.question] = answer
        });
        state.vitaminFormData.submitted.answers = answers;
      }
    },
    setAnswer(state, answer) {
      // set question answer to passed data
      state.vitaminFormData.draft.answers[answer.question] = answer;
    },
    reviewComment(state, question) {
      // set question answer to passed data
      state.vitaminFormData.submitted.answers[question.question].comment = question.comment;
    },
  },
  actions: {
    saveAllComments({commit}, settings) {
      this.state.userReviewComments.forEach(async (comment, ind) => {
        let save = {
          userid: settings.userid,
          submissionid: settings.submissionid,
          subcategoryid: comment.subcategoryid,
          text: comment.text
        };

        const existing = await axios.get('/comments?submissionid=' + settings.submissionid + '&subcategoryid=' + comment.subcategoryid);
        if (existing.data.length) {
          const existingcomment = existing.data[0];
          this.axios.put('/comments/' + existingcomment.id, save)
        } else {
          this.axios.post('/comments', save)
        }
      })
    },
    setLang({commit}, locale) {
      const datefields = this.getters.getFlatpickrs;
      commit('setLang', locale.lang);
      localStorage.setItem('lang', locale.lang);
      //  console.log('language to', locale);

      let options = {
        altInput: true,
        altFormat: "d/m/Y",
        locale: locale.lang,
        maxDate: moment().format('YYYY-MM-DD')
        // dateFormat: 'd/m/Y',
        // defaultDate:moment().format('d/m/Y')
      };

      datefields.forEach(field => {
        // console.log('field',field)
        options.defaultDate = field.value;
        flatpickr(field, options);
      })


    },
    setTree({commit}, tree) {
      const date = moment().format();
      commit('setTree', tree);
      commit('setTreeTime', date);
      // console.log('setting tree', [tree, date]);
      localStorage.setItem('tree', JSON.stringify(tree));
      localStorage.setItem('treeTime', JSON.stringify(date));
    },
    setManagerTree({commit}, tree) {
      const date = moment().format();
      commit('setManagerTree', tree);
      commit('setManagerTreeTime', date);
      //  console.log('setting manager tree', [tree, date]);
      localStorage.setItem('managertree', JSON.stringify(tree));
      localStorage.setItem('treeManagerTime', JSON.stringify(date));
    },
    setTheme({commit}, theme) {
      // console.log('setting theme to ', theme)
      localStorage.setItem('theme', theme);
      commit('setTheme', theme)
    },
    setUser({commit}, user) {
      commit('setUser', user);
      localStorage.setItem('user', JSON.stringify(user)) // store the token in localstorage
    },
    addFilter({commit}, filter) {
      commit('addTeamFilter', filter)
    },
    removeFilter({commit}, index) {
      commit('removeTeamFilter', index)
    },
    clearFilters({commit}) {
      commit('removeAllFilters')
    },
    switchView({commit, dispatch}, mode) {
      // console.log('switching to ', mode)
      localStorage.setItem('viewMode', mode);
      commit('changeViewMode', mode)
    },
    signup({commit, dispatch}, authData) {
      // console.log('authData', authData)
      globalAxios.post('http://localhost:1337/users', {
        username: authData.username,
        firstname: authData.firstname,
        lastname: authData.lastname,
        email: authData.email,
        password: authData.password,
        returnSecureToken: true
      }).then(res => {
        // console.log('trying to sign in', res)
        dispatch('signin', {email: authData.email, password: authData.password});
      }).catch(error => console.log(error))
    },
    signout({commit}) {
      commit('signOut');
      localStorage.clear();
      localStorage.removeItem('user-token');
    },
    forgotPassword({commit}, authData) {
      // console.log(authData.email)
      return globalAxios
        .post(this.getters.getUrl + ':' + this.getters.getPort + '/auth/forgot-password', {
          email: authData.email
        })
    },
    resetPassword({commit}, authData) {
      return globalAxios
        .post(this.getters.getUrl + ':' + this.getters.getPort + '/auth/reset-password', {
          code: authData.privateCode,
          password: authData.password,
          passwordConfirmation: authData.passwordConfirmation,
        })
        .then(response => {
          // Handle success.
          // console.log("Your user's password has been changed.");
        })
        .catch(error => {
          // Handle error.
          // console.log('An error occurred:', error.response);
        });
    },
    signin({commit}, authData) {
      localStorage.clear();
      return globalAxios
        .post(this.getters.getUrl + ':' + this.getters.getPort + '/auth/local', {
          identifier: authData.email,
          password: authData.password,
        })
        .then(res => {
          localStorage.setItem('user-token', res.data.jwt) // store the token in localstorage
          // localStorage.setItem('user', JSON.stringify(res.data.user)) // store the token in localstorage
          localStorage.setItem('user-id', res.data.user.id) // store the token in localstorage

          this.dispatch('setUser', res.data.user);


          commit('authUser', {
            token: res.data.jwt,
            userId: res.data.user.id,
            user: res.data.user
          });
          authData.vm.axios.defaults.headers = {
            Authorization:
              'Bearer ' + this.state.idToken,
          };
          let userRole = this.getters.getUser.role.name;
          // console.log('role', userRole);
          if (userRole === 'HR') {
            this.dispatch('switchView', 'hr');
            router.push('/dashboard-hr')
          } else {
            this.dispatch('switchView', 'user');
            router.push('/')
          }
        })
    },
  },
  getters: {
    getCountries(state){
      return state.countries
    },
    getReviewComments(state) {
      return state.reviewComments
    },
    getSubmittedAnswers(state) {
      return state.submittedAnswers
    },
    getPreviousAnswers(state) {
      return state.previousAnswers
    },
    getVitaminFormData(state) {
      return state.vitaminFormData
    },
    getFlatpickrs(state) {
      return state.flatpickrElements
    },
    getUrl(state) {
      return state.url
    },
    getPort(state) {
      return state.port
    },
    getManagedTeams(state) {
      return state.managedTeams;
    },
    isSetupCompleted(state) { //todo check if users exist and if runtime config is filled
      return state.setupComplete;
    },
    getTree(state) {
      return state.teamTree;
    },
    getManagerTree(state) {
      return state.teamManagerTree;
    },
    getTreeTimestamp(state) {
      return state.treeTime;
    },
    getManagerTreeTimestamp(state) {
      return state.treeManagerTime;
    },
    getTreeStorage(state) {
      return state.teamTree;
    },
    getUser(state) {
      if (isJson(state.user)) {
        return JSON.parse(state.user);
      } else {
        return state.user;
      }
    },
    getCompany(state) {
      return state.company;
    },
    getUserId(state) {
      return state.userId;
    },
    getTheme(state) {
      return state.theme;
    },
    getLang(state) {
      return state.lang;
    },

    theme(state) {
      return state.theme;
    },
    teamFilters(state) {
      // console.log('teamfilter getter', state.teamFilters)
      return state.teamFilters;
    },
    vitaminDraft(state) {
      return state.vitaminFormData.draft;
    },
    vitaminPrevious(state) {
      return state.vitaminFormData.previous;
    },
    vitaminSubmitted(state) {
      return state.vitaminFormData.submitted;
    },
    isAuthenticated(state) {
      // console.log('token', state.idToken)
      return state.idToken !== null;
    },
    viewMode(state) {
      return state.viewMode;
    },
    getDraft(state){
      return state.answers
    },
    getPrevious(state){
      return state.lastanswers
    },
    getCommentCount(state) {
      return state.commentCount;
    },
    getConfig(state){
      return state.config
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/store.js